"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YandexScriptError = exports.YandexMonitor = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _shared = require("@cian/peperrors/shared");
var _browser = require("@cian/logger/browser");
var _browser2 = require("@cian/http-api/browser");
var _telemetry = require("../telemetry");
/**
 * Хелпер-класс для логирования по яндекс-саджесту в браузере
 * Умеет отправлять телеметрию (с инициализацией начала отсчета времени)
 * Умеет логировать, при этом использует либо error либо warning в зав-ти от поля isStrict
 * */

class YandexMonitor {
  constructor(config) {
    (0, _defineProperty2.default)(this, "isStrict", void 0);
    (0, _defineProperty2.default)(this, "mcsName", void 0);
    (0, _defineProperty2.default)(this, "httpApi", void 0);
    (0, _defineProperty2.default)(this, "logger", void 0);
    (0, _defineProperty2.default)(this, "trackTelemetryTimer", void 0);
    this.isStrict = config.isStrict;
    this.httpApi = (0, _browser2.getHttpApi)();
    this.logger = (0, _browser.getLogger)();
    this.mcsName = config.mcsName;
    this.trackTelemetryTimer = this.prepareTelemetryTimerTracker();
  }
  get loggingMethod() {
    /** Если не забайндить, контекст теряется и логгер не работает.  */
    return this.isStrict ? this.logger.error.bind(this.logger) : this.logger.warning.bind(this.logger);
  }
  prepareTelemetryTimerTracker() {
    const startTimeRequest = new Date().getTime();
    return () => {
      const endTimeRequest = new Date().getTime() - startTimeRequest;
      (0, _telemetry.sendTelemetryTimer)({
        httpApi: this.httpApi,
        key: `${this.mcsName}.yandex-suggest.timer`,
        value: endTimeRequest
      });
    };
  }
  sendTelemetryCounter() {
    (0, _telemetry.sendTelemetryCounter)({
      httpApi: this.httpApi,
      key: `${this.mcsName}.yandex-suggest.200`
    });
  }
  sendTelemetryTimer() {
    this.trackTelemetryTimer();
  }
  log(e) {
    this.loggingMethod('Invalid yandex suggest api request', {
      errorMessage: e.message
    });
  }
}

/**
 * Эту ошибку следует бросать, когда происходит ошибка внутри яндекс-скрипта
 * Например, такую ошибку можно отловить, если отключить интернет или заблокировать url яндекс саджеста
 * */
exports.YandexMonitor = YandexMonitor;
class YandexScriptError extends _shared.GenericError {
  constructor() {
    const props = {
      message: 'Yandex suggest script error',
      type: YandexScriptError.name,
      domain: ''
    };

    /* istanbul ignore next */
    super(props);
    Object.setPrototypeOf(this, YandexScriptError.prototype);
  }
}
exports.YandexScriptError = YandexScriptError;